import MatriculasIndexPage from "@/Pages/Matriculas/index.vue";
import NewEditMatriculaPage from "@/Pages/Matriculas/NewEditMatriculaPage.vue";
import DesempenhoNotaAluno from "@/Pages/Matriculas/DesempenhoNotaAluno.vue";
import DesempenhoPedagogicoAlunoPage from "@/Pages/Matriculas/DesempenhoPedagogicoAluno/DesempenhoPedagogicoAlunoPage.vue";
import { can } from "@/plugins/can";

export default [
  {
    path: "/matriculas/",
    name: "matriculas",
    component: MatriculasIndexPage,
  },
  {
    path: "/matriculas/create",
    name: "matriculas.create",
    component: NewEditMatriculaPage,
    props: { editing: false },
  },
  {
    path: "/matriculas/edit/:matricula_id",
    name: "matriculas.edit",
    component: NewEditMatriculaPage,
    props: { editing: true },
  },
  {
    path: "/matriculas/desempenho-de-notas-do-aluno/matricula/:matricula_id",
    name: "matriculas.desempenhoNota",
    component: DesempenhoNotaAluno,
    props: { editing: true },
  },
  {
    path: "/matriculas/desempenho-pedagogico-do-aluno",
    name: "matriculas.desempenhoPedagogicoAluno",
    component: DesempenhoPedagogicoAlunoPage,
    beforeEnter(to, from, next) {
      if (!can(["desempenhoPedagogico.desempenhoAluno"])) {
        return next({ name: "NaoAutorizado" });
      }
      return next();
    },
  },
];
